<template>
  <search-layout class="report-search" header="案件查询">
    <van-tabs color="#1989fa" :border="false">
      <van-tab title="使用报案号查询">
        <van-form :show-error-message="false" @submit="onSearchWithReportNo">
          <van-field
            clearable
            v-model="reportNo"
            name="reportNo"
            label="报案号"
            placeholder="请输入报案号"
            :rules="[{ required: true, message: '请输入报案号' }]"
          ></van-field>

          <van-field
            name="certTypeName"
            :value="certTypeName"
            label="证件类型"
            placeholder="请选择证件类型"
            readonly
            clickable
            is-link
            @click="showPicker = true"
            :rules="[
              {
                required: true,
                trigger: 'onChange',
                message: '请选择证件类型',
              },
            ]"
          />

          <van-field
            clearable
            v-model="certNo"
            name="certNo"
            label="证件号码"
            placeholder="请输入证件号码"
            :rules="[{ required: true, message: '请输入证件号码' }]"
          ></van-field>
          <div class="submit-action">
            <van-button
              class="submit-btn"
              block
              type="info"
              native-type="submit"
            >
              查询
            </van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="使用保单号查询">
        <van-form :show-error-message="false" @submit="onSearchWithPolicyNo">
          <van-field
            clearable
            v-model="policyNo"
            name="policyNo"
            label="保单号"
            placeholder="请输入保单号"
            :rules="[{ required: true, message: '请输入保单号' }]"
          ></van-field>
          <van-field
            name="certTypeName"
            :value="certTypeName"
            label="证件类型"
            placeholder="请选择证件类型"
            readonly
            clickable
            is-link
            @click="showPicker = true"
            :rules="[
              {
                required: true,
                trigger: 'onChange',
                message: '请选择证件类型',
              },
            ]"
          />
          <van-field
            clearable
            v-model="certNo"
            name="certNo"
            label="证件号码"
            placeholder="请输入证件号码"
            :rules="[{ required: true, message: '请输入证件号码' }]"
          ></van-field>
          <div class="submit-action">
            <van-button
              class="submit-btn"
              block
              type="info"
              native-type="submit"
            >
              查询
            </van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="certTypes"
        @confirm="onPickerCert"
        @cancel="showPicker = false"
      />
    </van-popup>
  </search-layout>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import * as constants from '@/utils/constants';
import * as services from '@/services';

export default {
  name: 'ReportSearch',
  components: {
    SearchLayout,
  },

  data() {
    return {
      certTypes: constants.CERT_TYPES,
      showPicker: false,
      policyNo: '',
      reportNo: '',
      certType: '',
      certTypeName: '',
      certNo: '',
    };
  },

  methods: {
    onPickerCert(selected, index) {
      this.certTypeName = selected.name;
      this.certType = selected.value;
      this.showPicker = false;
    },

    onSearchWithReportNo(value) {
      const { reportNo, certType, certNo } = this;

      Toast.loading({
        message: '正在查询',
        forbidClick: true,
        duration: 0,
      });

      services.getReport(reportNo, certType, certNo).then(res => {
        const query = { reportNo, certType, certNo };
        this.$router.push({ name: 'report-detail', query });
        Toast.clear();
      });
    },

    onSearchWithPolicyNo(value) {
      const { policyNo, certType, certNo } = this;

      Toast.loading({
        message: '正在查询',
        forbidClick: true,
        duration: 0,
      });

      services.getReportsWithPolciyNo(policyNo, certType, certNo).then(res => {
        const query = { policyNo, certType, certNo };
        this.$router.push({ name: 'report-list', query });
        Toast.clear();
      });
    },
  },
};
</script>

<style lang="less">
.report-search {
  .van-tab__pane {
    padding: 10px 0;
  }

  .submit-action {
    margin: 12px 16px;
  }
}
</style>
